/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
/* eslint-disable import/extensions */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.appliancePackage = (await import('./pages/appliance-package/AppliancePackageContainer')).AppliancePackageContainer;
    Components.package = (await import('./pages/package/PackageContainer')).PackageContainer;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  // appliancePackage: {
  //   name: 'AppliancePackageContainer',
  //   componentName: 'AppliancePackageContainer',
  //   chunk: () => import('./pages/appliance-package/AppliancePackageContainer'),
  //   get component() {
  //     return ssr
  //       ? serverPages.appliancePackage
  //       : currentRouteName === 'AppliancePackageContainer'
  //         ? currentRouteComponent
  //         : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.AppliancePackageContainer })));
  //   },
  //   path: '/:context?/p/sets/appliances/:seo1?/:seo2?/:slug?/:packageId/*',
  //   channel: null
  // },
  package: {
    name: 'PackageContainer',
    componentName: 'PackageContainer',
    chunk: () => import('./pages/package/PackageContainer'),
    get component() {
      return ssr
        ? serverPages.package
        : currentRouteName === 'PackageContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PackageContainer })));
    },
    path: '/:context?/p/sets/:productCategory/:seo1?/:seo2?/:slug?/:packageId/*',
    channel: null
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/*',
    channel: null
  },
});
